import { render, staticRenderFns } from "./insuranceCompany.vue?vue&type=template&id=c1324fec&scoped=true"
import script from "./insuranceCompany.vue?vue&type=script&lang=js"
export * from "./insuranceCompany.vue?vue&type=script&lang=js"
import style0 from "./insuranceCompany.vue?vue&type=style&index=0&id=c1324fec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1324fec",
  null
  
)

export default component.exports